/* Kipor – FAQ mit Kategorien-Tabs.
   Ohne JS: alle Kategorien sichtbar, Navigation = Sprunglinks.
   Mit JS: ARIA-Tabs (Pfeiltasten, Pos1/Ende), Deeplink per #Kategorie-ID. */
if (!customElements.get('kipor-faq-tabs')) {
  customElements.define('kipor-faq-tabs', class KiporFaqTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length || !this.panels.length) return;
      this._ready = true;

      const list = this.querySelector('[data-tablist]');
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', window.matchMedia('(max-width: 749px)').matches ? 'horizontal' : 'vertical');
      this.tabs.forEach((tab) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.tab);
        if (tab.parentElement) tab.parentElement.setAttribute('role', 'presentation');
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.select(tab, true);
        });
        tab.addEventListener('keydown', (e) => this.onKey(e, tab));
      });
      this.panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        const tab = this.tabs.find((t) => t.dataset.tab === panel.id);
        if (tab) panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
      });

      const fromHash = window.location.hash && this.tabs.find((t) => '#' + t.dataset.tab === window.location.hash);
      this.select(fromHash || this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0], false);
      this.classList.add('is-ready');
    }

    select(tab, focus) {
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.panels.forEach((p) => p.classList.toggle('is-active', p.id === tab.dataset.tab));
      if (focus) {
        tab.focus({ preventScroll: true });
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    onKey(e, tab) {
      const i = this.tabs.indexOf(tab);
      let next = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
      else if (e.key === 'Home') next = this.tabs[0];
      else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
      else if (e.key === ' ' || e.key === 'Enter') next = tab;
      if (next) {
        e.preventDefault();
        this.select(next, true);
      }
    }
  });
}

/* Theme-Editor: Block auswählen → passende Kategorie anzeigen */
document.addEventListener('shopify:block:select', (e) => {
  const el = e.target;
  const root = el.closest && el.closest('kipor-faq-tabs');
  if (!root || !root.select) return;
  const tab = el.matches('[data-tab]') ? el : null;
  const panel = tab ? null : el.closest('[data-panel]');
  const target = tab || (panel && root.tabs.find((t) => t.dataset.tab === panel.id));
  if (target) root.select(target, false);
});
